import React, { useContext, useEffect } from "react";
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import { UserContext } from "../../components/context/userContext";

interface LoginValues {
  email: string; // Change "email" to "username"
  password: string;
}

const LoginScreen = () => {
  const { doLogin, isAuthenticated } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/acceuil");
    }
  }, [isAuthenticated]);

  return (
    <div className="login-screen-container">
      <NavBar />
      <div className="container">
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .required("Required")
              .email("Invalid email address"),
            password: Yup.string().required("Required"),
          })}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              doLogin(values.email, values.password);
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form className="form-container" onSubmit={handleSubmit}>
              <h2>Connectez à votre compte</h2>
              <div className="input-container">
                <input
                  type="text"
                  placeholder="Enter email or phone"
                  className="input"
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                />
                {errors.email && touched.email && (
                  <p className="error-message">{errors.email}</p>
                )}
              </div>
              <div className="input-container">
                <input
                  type="password"
                  placeholder="Password"
                  className="input"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                />
                {errors.password && touched.password && (
                  <p className="error-message">{errors.password}</p>
                )}
              </div>
              <div className="remember-me-container">
                <label className="checkbox-container">
                  <input type="checkbox" />
                  Remember Me
                </label>
                <a
                  className="forgot-password"
                  onClick={() => navigate("/forgetpassword")}
                >
                  mot de passe oublier ?
                </a>
              </div>
              <button
                type="submit"
                className="login-button"
                disabled={isSubmitting}
              >
                Connectez pour Continuer
              </button>
              <p className="sign-up-text">
                T'as pas créé un compte ?
                <a className="sign-up-link" onClick={() => navigate("/signup")}>
                  s'inscrire
                </a>
              </p>
            </form>
          )}
        </Formik>
      </div>
      <Footerr />
    </div>
  );
};

export default LoginScreen;
